import React, { lazy, Suspense } from 'react';

import type { EditorProps } from './editor';
import { LoadingFallback } from './loading-fallback';

const Editor = lazy(() => import('./editor'));

export const LazyEditor = (props: EditorProps) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Editor {...props} />
    </Suspense>
  );
};
